export default {
  methods: {
    determineUnit: function (value) {
      if (value >= 10000000000) {
        return 'TWh';
      } else if (value >= 10000000) {
        return 'GWh';
      } else if (value >= 10000) {
        return 'MWh';
      } else {
        return 'kWh';
      }
    },
    determineDateFormat(periodType) {
      const formats = {
        hour: 'HH:mm',
        day: 'yyyy-MM-dd',
        week: "'week' w",
        month: 'MMMM',
      };
      return formats[periodType];
    },
    formatAsUnit: function (value, unit) {
      let magnitude = {
        kWh: 1,
        MWh: 1000,
        GWh: 1000000,
        TWh: 1000000000,
      }[unit];
      return Number(value / magnitude);
    },
    yieldFormatter: function (value, precision = 4) {
      let unit = this.determineUnit(value);
      return {
        unitType: unit,
        value: Number(this.formatAsUnit(value, unit).toPrecision(precision)),
      };
    },
  },
};
